<template>
  <div class="form-group filter-item" @click="clearErrors">
    <label class="control-label">{{ filter.label }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="Press enter for search"
      :value="filter.value"
      v-on:blur="selectFilter"
      v-on:keyup.enter="selectFilter"
      :class="{'has-errors': filter.errors}"
    >


    <div v-for="error in filter.errors" class="filter-error">
      {{ error }}
    </div>
  </div>

</template>
<script>
export default {
  props: ['filter'],
  methods: {
    selectFilter($event) {
      let {value} = $event.target;

      if ((this.filter.value === undefined && !value) || this.filter.value === value) {
        return;
      }

      if (!value.replace(/ /g, '').length) {
        value = null
      }

      this.$set(this.filter, 'value', value)

      this.$emit('value-updated');
    },
    clearErrors() {
      if (this.filter.errors) {
        this.$delete(this.filter, 'errors')
      }
    }
  }
}
</script>
